import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class DeliveryCancel extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.state = {

			start_date 	: "",
			end_date 	: "",

			listado:[],

			columns:[	
				{title:'HOSPITAL ORIGEN', width:'150px'},
				{title:'CENTRO DESTINO', width:'150px'},
				{title:'TIPO DE CENTRO', width:'100px'},
				{title:'SERVICIO', width:'100px'},
				{title:'PACIENTE', width:'180px'},
				{title:'SEXO', width:'60px'},
				{title:'UNIDAD', width:'120px'},
				{title:'FECHA ENVIO', width:'110px'},
				{title:'FOLIO ENVIO', width:'100px'},
                {title:'USUARIO QUE ENVIÓ', width:'120px'},
				{title:'FECHA CANCELACIÓN', width:'110px'},
                {title:'USUARIO QUE CANCELÓ', width:'120px'},
                {title:'BAJA', width:'60px'},
                {title:'NUEVO ENVÍO', width:'100px'},
				{title:'NUEVO FOLIO ENVIO', width:'100px'},
                {title:'USUARIO NUEVO ENVÍO', width:'120px'},
                {title:'MOTIVO DE DEVOLUCIÓN', width:'120px'},
                {title:'OBSERVACIONES DE RECHAZO', width:'120px'},
                {title:'RAZÓN RETORNO EXPORTACIÓN', width:'120px'},
			],
			filename:"Envíos Cancelados",
			date_hour:"",
			totales:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			//health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	componentDidMount(){
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
			
			this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 

		this.$el = $(this.el);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdfHtml5',
                	title: this.state.filename,
                	orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas+'\t\t\t'+this.state.medical, margin:[10,0,0,10] });

                		/*doc.content[4] = {
							text:'Total: '+this.state.totales,
							margin:[5,15,0,0]
            			}*/

            			//doc.content[3].table.widths = ['5%','10%','10%','10%','15%','15%','10%','10%','15%'];
                		doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; //2,3,4,etc doc.styles.tableHeader.fontSize = 1; //2, 3, 4, etc 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	},
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:false,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			ordering:false,
			info:false,
			
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}

	}

	handleChange(e){
        this.setState({
            [e.target.name]: e.target.value
        });

        if(document.getElementById(e.target.name).className.includes('error')){
            document.getElementById(e.target.name).classList.remove('error');
        }
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){

				this.props.waiting.handleShow('Buscando...');

				var object = {};
				object.start_date = this.state.start_date;
				object.end_date = this.state.end_date;
				
				fetch(Config.default.apiGateway.URL+'reports/shipments_canceled', {
					method : 'post',
					body:JSON.stringify(object),
					responseType: 'blob', //Force to receive data in a Blob Format
					headers : new Headers({
						'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
						'Content-Type': 'application/json'
					})
				})
				.then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				})
				.then(response => {
					if(response !== undefined){
						var list = [];

						response.map((res)=>{
                            list.push([
                                res.origin_center,
                                res.destination_center,
                                res.type_center,
                                res.service,
                                res.patient_name,
                                res.patient_sex,
                                res.unit_number+' '+res.unit_component,
                                res.delivered_date !== null ? moment(res.delivered_date).format('DD/MM/YYYY HH:mm') : "",
								res.delivered_folio,
								res.delivery_user,
                                res.cancel_date !== null ? moment(res.cancel_date).format('DD/MM/YYYY HH:mm') : "",
                                res.cancellation_user !== null ? res.cancellation_user : "",
                                res.discard !== null ? res.discard : "",
                                res.new_delivered_date !== null ? moment(res.new_delivered_date).format('DD/MM/YYYY HH:mm') : "",
								res.new_delivered_folio,
								res.new_delivery_user !== null ? res.new_delivery_user : "",
								res.distribution_return_reason !== null ? res.distribution_return_reason : "",
								res.request_reject_observations !== null ? res.request_reject_observations : "",
								res.export_return_reason !== null ? res.export_return_reason : "",
                            ]);
                        })

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
								this.setTable();
						}, 1000);

						this.setState({
							listado: list,
						});
					}
						
				});
				
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}

		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Distribución ->
					{this.state.filename}
					</h5>
				</div>
				
				<Help 
					{...this.props}
		            menu={"help_distribution"} 
		            submenu={"help_shipments_canceled"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12"> 
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								<div className="col-xs-12 form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required  />
								</div>
								<div className="col-xs-12 form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>

								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									<div className="col-xs-12 col-sm-12" >
										<span>
											Información Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
											: ''}    
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ?
												moment(this.state.end_date).format("DD/MM/YYYY")
											: ''}
										</span>
									</div>
								</div>

								<div className="col-xs-12" id="table-to-pdf">
									<div className="table-responsive">

										<table style={{fontSize:"11px"}} className="expenses-discards" id="table-to-xls" ref={el => this.el = el}>
										</table>
									</div>

								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (DeliveryCancel);